import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext';
import { transformOptionsByPath } from '@openx/components-deal/lib/utils/transformOptionsByPath';
import type { Option } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery';

export const usePdpSyncDealStatusOptionsFetch: DealProviderConfig['usePdpSyncDealStatusOptionsFetch'] = () => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.pdp_deal_status_option_enum',
    },
    fetchPolicy: 'network-only',
  });

  const { list, mapById } = useMemo(() => transformOptionsByPath<Option>(optionsByPath), [optionsByPath]);

  return {
    list,
    loading,
    mapById,
    refetch,
  };
};
